import { A11yModule } from '@angular/cdk/a11y';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, Injector, NgModule } from '@angular/core';
import { SETTINGS } from '@lsq-frontend/angular-shared/settings';
import {
    errorHandlerFactory,
    LsqCoreModule,
    LsqModalsModule,
    ModalService,
    ModalServiceToken,
    SHA
} from '@lsq-frontend/common-ui';
import { environment } from '@lsq-frontend/fasttrack-shared/environment';
import { WhiteLabelModule } from '@lsq-frontend/fasttrack-shared/features/white-label-service';
import { UserIdleModule } from 'angular-user-idle';
import { GuidedTourModule } from 'ngx-guided-tour';
import { PopoverModule } from 'ngx-smart-popover';
import { AppCommonModule } from '../app-common.module';
import { AppDashboardComponent } from '../app-dashboard/app-dashboard.component';
import { AdditionalUploadsModalComponent } from '../customers/modals/additional-uploads-modal.component';
import { AdditionalUploadsRowItemComponent } from '../customers/modals/additional-uploads-row-item/additional-uploads-row-item.component';
import { AdvancedSearchModalComponent } from '../customers/modals/advanced-search-modal.component';
import { UploadsPreviewModalComponent } from '../customers/modals/uploads-preview-modal.component';
import { GlobalSearchModule } from '../global-search/global-search.module';
import { UnImpersonateGuard } from '../guards/un-impersonate.guard';
import { SwitchAccountComponent } from '../identity/switch-account/switch-account.component';
import { CheckPreviewComponent } from '../image-preview/check-preview.component';
import { DocumentPreviewComponent } from '../image-preview/document-preview.component';
import { ImagePreviewModalComponent } from '../image-preview/image-preview-modal.component';
import { InvoiceHistoricalPreviewComponent } from '../image-preview/invoice-historical-preview.component';
import { InvoicePreviewComponent } from '../image-preview/invoice-preview.component';
import { MobileUploadTokenComponent } from '../invoices/upload-invoices/mobile-upload-invoices/mobile-upload-token.component';
import { LsqCreateOrUpdateUserStateModalComponent } from '../local-management/user-state/lsq-create-user-state-modal.component';
import { RightNavigationItemsComponent } from '../navigation/right-navigation-items/right-navigation-items.component';
import { NotificationsModule } from '../notifications/notifications.module';
import { RegistrationRedirectComponent } from '../supply-chain-registration/supply-chain-registration-redirect.component';
import { RequestPaymentConfirmationModalComponent } from '../supply-chain/direct/seller/request-payment-confirmation-modal/request-payment-confirmation-modal.component';
import { FasttrackMonolithEntryComponent } from './entry.component';
import { FasttrackMonolithEntryRoutingModule } from './entry.routing.module';
import sha from '../app.sha.json';
import { BASE_PATH } from '@lsq-frontend/remote-services/ar-app';
import { RequestPaymentConfirmationModalV2Component } from '../supply-chain/direct/seller/request-payment-confirmation-modal/request-payment-confirmation-modal-v2.component';

@NgModule({
    imports: [
        A11yModule,
        CommonModule,
        HttpClientModule,
        CdkTableModule,
        PopoverModule,
        WhiteLabelModule,
        NotificationsModule,
        LsqCoreModule.forRoot(),
        LsqModalsModule,
        UserIdleModule.forRoot({
            idle: environment.idleTimerInSeconds,
            timeout: environment.idleModalLifespanInSeconds,
            ping: 0 // Not used.
        }),
        GuidedTourModule.forRoot(),
        GlobalSearchModule.forRoot(),
        AppCommonModule,
        FasttrackMonolithEntryRoutingModule
    ],
    declarations: [
        FasttrackMonolithEntryComponent,
        AdditionalUploadsRowItemComponent,
        AppDashboardComponent,
        CheckPreviewComponent,
        DocumentPreviewComponent,
        InvoiceHistoricalPreviewComponent,
        InvoicePreviewComponent,
        MobileUploadTokenComponent,
        RegistrationRedirectComponent,
        SwitchAccountComponent,

        // Modals
        AdditionalUploadsModalComponent,
        AdvancedSearchModalComponent,
        ImagePreviewModalComponent,
        RequestPaymentConfirmationModalComponent,
        RequestPaymentConfirmationModalV2Component,
        RightNavigationItemsComponent,
        UploadsPreviewModalComponent,
        LsqCreateOrUpdateUserStateModalComponent
    ],
    providers: [
        UnImpersonateGuard,
        {
            provide: ErrorHandler,
            useFactory: errorHandlerFactory,
            deps: [SETTINGS, Injector]
        },
        { provide: SHA, useValue: sha },
        { provide: ModalServiceToken, useExisting: ModalService },
        { provide: BASE_PATH, useValue: environment.httpApiServiceNameUrlMap.arApp }
    ]
})
export class RemoteEntryModule {
    constructor() {
        console.debug('Loading fasttrack-monolith/RemoteEntryModule.');
    }
}
